import { motion } from 'framer-motion'
import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  gap: ${({ theme }) => theme.spacing.sm}rem;

  & + & {
  margin-top: ${({ theme }) => theme.spacing.sm}rem;
`

export const ActionBarContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  z-index: 1;

  background-color: ${({ theme }) => theme.colors.neutralWhite};
  padding: ${({ theme }) => theme.spacing.md}rem;

  border-radius: ${({ theme }) => theme.borderRadius.md}rem
    ${({ theme }) => theme.borderRadius.md}rem 0 0;
  margin-bottom: 0;

  &.isLast {
    border-radius: ${({ theme }) => theme.borderRadius.md}rem;
    margin-bottom: 1rem;
  }
`

export const AdditionalContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`
